export default __webpack_public_path__ + "static/media/students_sel.ced3fb51.svg";